
import React from 'react';
import { Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SpotifyTrack } from '@/types';

interface TrackPreviewProps {
  track: SpotifyTrack;
  small?: boolean;
  compact?: boolean;
}

const TrackPreview: React.FC<TrackPreviewProps> = ({ track, small = false, compact = false }) => {
  return (
    <div className={`relative overflow-hidden rounded-md group ${small ? 'h-12' : 'h-20'}`}>
      <div className="absolute inset-0 flex">
        <div className="flex items-center justify-center bg-black/50 w-full h-full">
          <span className="text-xs text-white/70">Preview disabled</span>
        </div>
      </div>
      
      <div className="absolute inset-0 flex items-center justify-center bg-black/50 group-hover:bg-black/70 transition-colors">
        <div className="flex items-center gap-3">
          <Button 
            variant="ghost" 
            size="icon"
            className="rounded-full bg-white/10 hover:bg-white/20 text-white h-8 w-8"
            disabled
          >
            <Play className="h-4 w-4" />
          </Button>
          
          <div className={`${small ? 'hidden' : 'block'}`}>
            <div className="text-sm font-medium text-white line-clamp-1">
              {track.name}
            </div>
            <div className="text-xs text-white/70 line-clamp-1">
              {track.artists?.join(', ') || 'Unknown Artist'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackPreview;
